<template>
  <div>
    <AddPool />
    <EditPool />
    <button class="d-none" data-toggle="modal" data-target="#Teams" ref="openModalTeams"></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="Teams">
      <div class="modal-dialog modal-dialog-centered teammates-lineup-modal" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0 text-capitalize">
              Manage Division Teams - {{ tournamentData?.tournamentName }}
            </h6>
            <button type="button" class="close" data-dismiss="modal" @click="clearErrorMessage()" aria-label="Close"
              ref="closeTournamentLineUpModal">
              <img src="../../../assets/Svg/close.svg" alt="">
            </button>
          </div>
          <div class="modal-body">
            <div class="teammates-lineup-wrapper">
              <div class="available-teammates">
                <h6>Available Teams</h6>
                <div class="teammates-info overflow-hidden manage-teams pb-5">
                  <div class="search-container border-0 mx-2">
                    <form>
                      <button type="button">
                        <img src="../../../assets/images/search.png" alt="" />
                      </button>
                      <input v-model="searchValue" id="search-input" type="text"
                        placeholder="Search by team name or city" name="search" autocomplete="new-password"
                        v-on:keydown.enter.prevent />
                    </form>
                  </div>
                  <draggable class="list-group" :list="filteredAvailableTeams" group="umpires" handle=".handle"
                    @change="handleAvailableTeams" v-if="showLoaderAvailableTeams == 0">
                    <div class="list-group-item cursor-none" v-for="(element, index) in filteredAvailableTeams"
                      :key="index">
                      <div class="shirt-no-wrapper">
                        <small>{{ index + 1 }}.</small>
                        <div class="d-flex flex-column">
                          <p class="name">{{ element?.team?.team_name }}</p>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.age_group?.name ? element?.team.age_group?.name + '-' : '' }}
                            {{ element?.team?.gender ? element.team.gender + '-' : '' }}
                            {{ element?.team?.ratings?.rate }}
                          </small>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.city }},
                            {{ element?.team?.state }}
                          </small>
                        </div>
                      </div>
                      <div class="handle cursor-pointer">
                        <img src="../../../assets/images/line-ellipsis.png" alt=""
                          title="Click an icon to drag and drop the option." />
                      </div>
                    </div>
                  </draggable>
                  <div class="no-line-up" v-if="showLoaderAvailableTeams == 0 && filteredAvailableTeams.length == 0">
                    <div class="img">
                      <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No available Teams found.</p>
                  </div>
                  <div class="lds-dual-ring-media" v-if="showLoaderAvailableTeams == 1"></div>
                </div>
              </div>
              <div class="team-lineup mt-3 mt-md-0">
                <h6>Teams Selected</h6>
                <!-- <div class="teammates-info position-relative teams-selected">

                  <draggable class="list-group" :list="selectedTeams" group="umpires" handle=".handle"
                    @change="handleSelectedTeams" v-if="showLoaderSelectedTeams == 0">
                    <div class="list-group-item cursor-none" v-for="(element, index) in selectedTeams"
                      :key="element?.position_index">
                      <div class="shirt-no-wrapper">
                        <small>{{ index + 1 }}.</small>
                        <div class="d-flex flex-column">

                          <p class="name">{{ element?.team?.team_name }}</p>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.age_group?.name ? element.team.age_group.name + '-' : '' }}
                            {{ element?.team?.gender ? element.team.gender + '-' : '' }}
                            {{ element?.team?.ratings?.rate }}
                          </small>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.city }},
                            {{ element?.team?.state }}
                        </small>
                        </div>
                      </div>
                      <div class="handle cursor-pointer">
                        <img src="../../../assets/images/line-ellipsis.png" alt="" title="Click an icon to drag and drop the option."/>
                      </div>
                    </div>
                  </draggable>
                  <div class="no-line-up" v-if="showLoaderSelectedTeams == 0 && selectedTeams.length == 0">
                    <div class="img">
                      <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No selected Teams found.</p>
                  </div>
                  <div class="no-line-up" v-else-if="errorMessage">
                    <div class="img">
                      <img src="../../../assets/images/teammates-red.png" alt="" />
                    </div>
                    <p class="text-danger pl-2">{{ errorMessage }}</p>
                  </div>
                  <div class="lds-dual-ring-media" v-if="showLoaderSelectedTeams == 1"></div>
                </div> -->

                <div class="teammates-info position-relative teams-selected overflow-hidden">
                  <template>
                    <div class="d-flex align-items-center p-2">
                      <div class="form-group pool-select-input">
                        <select v-model="currentPoolName" class="pool-selection"
                          @change="getPoolSelectedTeamsForTournament(currentPoolName)" :disabled="pools.length === 0">

                          <option disabled value="">
                            {{ pools.length === 0 ? 'Please add a pool to select' : 'Select Pool' }}
                          </option>

                          <option v-for="pool in pools" :key="pool.id" :value="pool.id">
                            {{ pool.pool_name }}
                          </option>
                        </select>
                      </div>
                      <div class="d-flex justify-content-between ml-2">
                        <div class="d-flex" style="gap:8px">
                          <div class="outline-icon cursor-pointer" @click="openEditPoolModal()"><img
                              src="../../../assets/Svg/team/team-options/edit-2.svg" alt=""></div>
                          <div class="outline-icon cursor-pointer" @click="openAddPoolModal()">
                            <img src="../../../assets/Svg/add-btn.svg" alt="" />
                          </div>
                        </div>
                        <div class="event-btns-wrapper">
                          <button type="button" class="btn btn-primary btn-primary-custom" :disabled="isLoading"
                            @click="assignTeamsToPool()">
                            <div v-if="isLoading" class="lds-dual-ring"></div>
                            <div v-else>
                              <img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save Pool Teams
                            </div>
                          </button>

                          <!-- <button v-else type="button" class="btn btn-primary-disabled" disabled>
                              <div>
                                <img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save Pool
                              </div>
                            </button> -->
                        </div>
                      </div>
                    </div>

                  </template>

                  <draggable class="list-group" :list="selectedTeams" group="umpires" handle=".handle"
                    @change="handleSelectedTeams" v-if="showLoaderSelectedTeams == 0">
                    <!-- Existing Layout -->
                    <div class="list-group-item cursor-none" v-for="(element, index) in selectedTeams"
                      :key="element?.position_index">
                      <div class="shirt-no-wrapper">
                        <small>{{ index + 1 }}.</small>
                        <div class="d-flex flex-column">

                          <p class="name">{{ element?.team?.team_name }}</p>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.age_group?.name ? element.team.age_group.name + '-' : '' }}
                            {{ element?.team?.gender ? element.team.gender + '-' : '' }}
                            {{ element?.team?.ratings?.rate }}
                          </small>
                          <small class="pt-1 age-group-content text-capitalize">
                            {{ element?.team?.city }},
                            {{ element?.team?.state }}
                          </small>
                        </div>
                      </div>
                      <div class="handle cursor-pointer">
                        <img src="../../../assets/images/line-ellipsis.png" alt=""
                          title="Click an icon to drag and drop the option." />
                      </div>
                    </div>
                  </draggable>
                  <div class="no-line-up" v-if="showLoaderSelectedTeams == 0 && selectedTeams.length == 0">
                    <div class="img">
                      <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No selected Teams found.</p>
                  </div>
                  <!-- <div class="no-line-up" v-else-if="errorMessage">
                    <div class="img">
                      <img src="../../../assets/images/teammates-red.png" alt="" />
                    </div>
                    <p class="text-danger pl-2">{{ errorMessage }}</p>
                  </div> -->
                  <div class="lds-dual-ring-media" v-if="showLoaderSelectedTeams == 1"></div>
                </div>

              </div>
            </div>
          </div>
          <div class="event-btns-wrapper pt-3 justify-content-end">
            <button v-if="isDisabled" type="button" class="btn btn-primary" @click="manageTournamentTeam(0)"
              :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Close</div>
            </button>
            <button v-else type="button" class="btn btn-primary-disabled" :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Close</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import AddPool from "../../Association/Modals/AddPool.vue";
import EditPool from "../../Association/Modals/EditPool.vue";
export default {
  name: "TournamentTeamsModal",
  data: function () {
    return {
      tournamentData: [],
      tournament_id: "",
      tournament_guid: "",
      eventId: "",
      availableTeams: [],
      selectedTeams: [],
      isDisabled: true,
      isLoadingArray: [],
      showLoaderSelectedTeams: 1,
      showLoaderAvailableTeams: 1,
      searchValue: "",
      errorMessage: "",
      editPoolName: '',
      isDisabledPool: true,
      isLoading: false,
      newPoolName: "",
      poolPlay: '',
      pools: [], // array of { name: string, teams: [] }
      pools_data: {},
      currentPoolName: "",
      showLoader1: 0,
      isAssigningTeams: false,
      isFetchingSelectedTeams: false,
      isFetchingPoolTeams: false,


    };
  },
  components: {
    draggable,
    AddPool,
    EditPool
  },
  watch: {
    pools(newVal) {
      if (!newVal.length) {
        this.currentPoolName = '';
      }
    },
  },

  computed: {
    filteredAvailableTeams() {
      const lowercasedSearchValue = this.searchValue.toLowerCase();
      return this.availableTeams.filter((team) => {
        const isSelected = this.selectedTeams.some(selected => selected.team.id === team.team.id);
        // const ageGroupName = team.team.age_group.name.toLowerCase();
        const teamName = team.team.team_name.toLowerCase();
        return !isSelected && (teamName.includes(lowercasedSearchValue));
      });
    },
  },
  methods: {
    async manageTournamentTeam(index) {
      if (!this.currentPoolName) {
        this.errorMessage = "Please select a pool.";
        return;
      }
      this.isDisabled = false;
      this.$set(this.isLoadingArray, index, true);

      const currentPool = this.pools.find(p => p.id === this.currentPoolName);
      if (!currentPool) {
        this.errorMessage = "Selected pool does not exist.";
        return;
      }
      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/addTeamsToPools`;

        const response = await axios.post(url, {
          event_id: this.eventId,
          tournament_id: this.tournament_id,
          tournament_guid: this.tournament_guid,
          pools: [
            {
              id: currentPool.id, // assuming you have a currentPool defined in data or computed
              teams: JSON.parse(JSON.stringify(this.selectedTeams)) // deep copy of selected teams
            }
          ]
        });

        if (response.data.statusCode === 200) {
          this.isDisabled = true;

          if (response.data.associatedTeam == 1) {
            this.$alert(response.data.message);
          } else {
            // this.$alert(response.data.message, "Success");
          }
          this.$root.$emit("selectedTournamentTeamEmit");
          this.$root.$emit("fetchTournaments"); // Refresh tournaments
          const elem = this.$refs.closeTournamentLineUpModal;
          if (elem) {
            elem.click();
          }
        } else if (response.data.statusCode === 404) {
          this.isDisabled = true;
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.showLoader1 = 0;
        } else {
          console.error("Failed to add teams. Status:", response.status);
        }
      } catch (error) {
        console.error("Error saving selected teams:", error);
      } finally {
        this.isDisabled = true;
        this.$set(this.isLoadingArray, index, false);
      }
    },
    handleAvailableTeams(evt) {
      if (evt.added) {
        const addedTeam = evt.added.element;

        // Add to selectedTeams regardless
        this.selectedTeams.push(addedTeam);

        // Remove from availableTeams safely
        if (addedTeam && addedTeam.team && addedTeam.team.id) {
          this.availableTeams = this.availableTeams.filter(team =>
            !team.team || team.team.id !== addedTeam.team.id
          );
        } else {
          // If we can't filter by ID, remove by index
          const index = evt.added.oldIndex;
          if (index >= 0 && index < this.availableTeams.length) {
            this.availableTeams.splice(index, 1);
          }
        }
      }
    },
    handleSelectedTeams(evt) {

      if (evt.removed) {
        const removedTeam = evt.removed.element;

        if (removedTeam === undefined) {
          // If the element is undefined, try to remove by index
          const index = evt.removed.oldIndex;

          if (index >= 0 && index < this.selectedTeams.length) {
            // Remove the item at the index and capture it
            const removedItem = this.selectedTeams.splice(index, 1)[0];

            // If we successfully removed something, add it to available teams
            if (removedItem) {
              this.availableTeams.push(removedItem);
            }
          }
        } else {
          // Normal flow if element exists
          this.availableTeams.push(removedTeam);
          this.selectedTeams = this.selectedTeams.filter(team =>
            team.team && team.team.id !== removedTeam.team.id
          );
        }
      }
    },
    async getTeamsForTournament() {
      try {
        this.showLoaderAvailableTeams = 1;
        this.isDisabled = false;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}associationEvent/getJoinedTeamForTournament?event_id=${this.tournamentData?.event_id}&tournament_id=${this.tournamentData?.id}`);

        if (response.data.statusCode === 200) {
          this.isDisabled = true;

          this.availableTeams = response.data.data;

          // Inline sorting logic
          this.availableTeams.sort((a, b) => {
            const extractNumber = (str) => parseInt(str.match(/\d+/), 10);
            const isOlder = (str) => str.toLowerCase().includes("older");
            const ageA = a?.team?.age_group?.name || "";
            const ageB = b?.team?.age_group?.name || "";

            const numA = extractNumber(ageA);
            const numB = extractNumber(ageB);

            if (!isOlder(ageA) && !isOlder(ageB)) {
              // Both are U categories
              return numA - numB;
            } else if (isOlder(ageA) && isOlder(ageB)) {
              // Both are Older categories
              return numA - numB;
            } else if (!isOlder(ageA) && isOlder(ageB)) {
              // U category should come before Older category
              return -1;
            } else {
              // Older category should come after U category
              return 1;
            }
          });

          this.showLoaderAvailableTeams = 0;
        } else if (response.data.statusCode === 404) {
          this.isDisabled = true;
          const elem = this.$refs.closeTournamentLineUpModal;
          if (elem) {
            elem.click();
          }
        } else {
          this.isDisabled = true;
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderAvailableTeams = 0;
        }
      } catch (error) {
        this.isDisabled = true;
        this.errorMessage = "Failed to fetch data";
        this.showLoaderAvailableTeams = 0;
      }
    },
    closeModal(refName = 'closeTournamentLineUpModal') {
      const elem = this.$refs[refName];
      if (elem) {
        elem.click();
      }
    },
    async getSelectedTeamsForTournament() {
      // Prevent multiple requests
      if (this.isFetchingSelectedTeams) return;
      this.isFetchingSelectedTeams = true;
      this.showLoaderSelectedTeams = 1;

      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/getSelectedTournamentTeams?tournament_guid=${this.tournamentData?.guid}`;
        const response = await axios.get(url);

        if (response.data.statusCode === 200) {
          this.pools_data = response.data.data;
          this.pools = response.data.data.pools;

          if (this.pools.length > 0) {
            // Sort pools by latest update
            const sortedPools = [...this.pools].sort(
              (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
            );

            this.currentPoolName = sortedPools[0].id;

            // Ensure we wait for pool fetch before ending loader
            await this.getPoolSelectedTeamsForTournament(this.currentPoolName);
          }
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          const elem = this.$refs.closeTournamentLineUpModal;
          if (elem) {
            elem.click();
          }
          this.$router.push({ name: "Teams" });
        } else {
          console.error("Failed to fetch teams:", response.data.message);
        }
      } catch (error) {
        console.error("Failed to fetch teams:", error);
      } finally {
        this.showLoaderSelectedTeams = 0;
        this.isFetchingSelectedTeams = false;
      }
    },

    // FETCH POOL TEAMS
    async getPoolSelectedTeamsForTournament(poolId) {
      if (this.isFetchingPoolTeams) return;
      this.isFetchingPoolTeams = true;
      this.showLoaderSelectedTeams = 1;

      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/getPoolSelectedTournamentTeams?tournament_guid=${this.tournamentData?.guid}&pool_id=${poolId}`;
        const response = await axios.get(url);

        if (response.data.statusCode === 200) {
          this.selectedTeams = response.data.data.teams;

          // Sort logic
          this.selectedTeams.sort((a, b) => {
            const extractNumber = (str) => parseInt(str.match(/\d+/), 10);
            const isOlder = (str) => str.toLowerCase().includes("older");

            const ageA = a?.team?.age_group?.name || "";
            const ageB = b?.team?.age_group?.name || "";

            const numA = extractNumber(ageA);
            const numB = extractNumber(ageB);

            if (!isOlder(ageA) && !isOlder(ageB)) return numA - numB;
            else if (isOlder(ageA) && isOlder(ageB)) return numA - numB;
            else if (!isOlder(ageA)) return -1;
            else return 1;
          });
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
        } else {
          console.error("Failed to fetch pool teams:", response.data.message);
        }
      } catch (error) {
        console.error("Failed to fetch pool teams:", error);
      } finally {
        this.showLoaderSelectedTeams = 0;
        this.isFetchingPoolTeams = false;
      }
    },
    clearErrorMessage() {
      this.errorMessage = "";
    },
    openAddPoolModal(from = "editTeam") {
      this.$refs.closeTournamentLineUpModal?.click();
      setTimeout(() => {
        this.$root.$emit("openAddPoolModal2", { tournament_id: this.tournament_id, tournament_guid: this.tournament_guid, source: from, tournamentData: this.tournamentData });
      }, 500);
    },
    openEditPoolModal(from = "editTeam") {
      if (!this.pools.length) {
        this.$alert("Please add a pool to edit.");
        return;
      }
      if (from === "addTournament") {
        this.$refs.closeModalAddTournament?.click();
      } else if (from === "editTeam") {
        this.$refs.closeTournamentLineUpModal?.click();
      }
      const selectedPool = this.pools.find(pool => pool.id === this.currentPoolName);

      if (selectedPool) {
        setTimeout(() => {
          this.$root.$emit("openEditPoolModal2", {
            id: selectedPool.id,
            name: selectedPool.pool_name,
            tournament_id: this.tournament_id, // ensure this exists in each pool object
            tournament_guid: this.tournament_guid, // ensure this exists in each pool object
            source: from, // pass the source modal name
            tournamentData: this.tournamentData

          });
        }, 100);

      } else {
        console.warn("Selected pool not found.");
      }
    },
    async assignTeamsToPool() {
      if (this.isAssigningTeams) return; // ✅ Block if already in progress
      this.isAssigningTeams = true;

      if (!this.currentPoolName) {
        this.errorMessage = "Please select a pool.";
        this.isAssigningTeams = false;
        return;
      }

      const currentPool = this.pools.find(p => p.id === this.currentPoolName);
      if (!currentPool) {
        this.errorMessage = "Selected pool does not exist.";
        this.isAssigningTeams = false;
        return;
      }

      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/addTeamsToPools`;

        const payload = {
          event_id: this.eventId,
          tournament_id: this.tournament_id,
          tournament_guid: this.tournament_guid,
          pools: [
            {
              id: currentPool.id,
              teams: JSON.parse(JSON.stringify(this.selectedTeams))
            }
          ]
        };

        this.isLoading = true;
        const response = await axios.post(url, payload);
        this.isLoading = false;

        if (response.data.statusCode === 200) {
          this.$set(currentPool, 'teams', JSON.parse(JSON.stringify(this.selectedTeams)));

          if (response.data.associatedTeam === 1) {
            // this.$alert(response.data.message);
          }
          await this.getSelectedTeamsForTournament();
          this.availableTeams = [];
          await this.getTeamsForTournament();

          this.$root.$emit("selectedTournamentTeamEmit");
          this.$root.$emit("fetchTournaments");
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
        } else {
          console.error("Failed to assign teams. Status:", response.status);
        }
      } catch (error) {
        this.$alert("Failed to assign teams to pool", "Error");
        console.error("Error assigning teams to pool:", error);
      } finally {
        this.isLoading = false;
        this.isAssigningTeams = false; // ✅ Release the lock
      }
    },
  },
  mounted() {
    this.$root.$on("openTournamentTeamsModal", (data) => {
      this.tournamentData = data;
      this.tournament_id = data.id;
      this.tournament_guid = data.guid;
      this.eventId = data.event_id;
      this.selectedTeams = [];
      this.currentPoolName = "";
      this.filteredAvailableTeams = [];
      var elem = this.$refs.openModalTeams;
      this.clearErrorMessage;
      if (elem) {
        this.$nextTick(() => {
          elem.click();
          this.getSelectedTeamsForTournament();
          this.getTeamsForTournament();
        });
      }
    });
  },
};
</script>
<style scoped>
.manage-teams {
  height: 464px !important;
}
</style>